import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MaterialModel} from '../models/material';
import {DataService} from '../../services/data.service';
import {unities} from '../../interfaces/unit';
import {Material} from '../../interfaces';
import {ResumeMaterial} from '../../interfaces';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {CommonModule} from '@angular/common';


@Component({
  selector: 'app-item-material-form',
  templateUrl: './material-form.component.html',
  styleUrls: ['./material-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class MaterialFormComponent implements OnInit {

  @Input() public budgetId: string;
  @Input() public subBudgetId: string;
  @Input() public type: string;
  @Input() public forOrderBuild: boolean; // just return the material instead of saving it
  @Input() public assignPossibilities: Array<ResumeMaterial>;

  public referencedMaterialId: string;
  @Output() onSubmit = new EventEmitter<MaterialModel>();
  model = new MaterialModel();
  categories = [];
  unities = unities;
  submitted = false;

  constructor(private dataService: DataService) {
  }

  get material(): Material {
    return this.model.toPlainObj();
  }

  @Input() set material(m: Material) {
    if (m) {
      this._editMode = true;
      this.model = MaterialModel.fromObj(m);
    } else {
      this._editMode = false; // New obj
    }
  }

  private _editMode = false;

  get editMode(): boolean {
    return this._editMode;
  }

  public changeRef(event) {
    console.log('choosed:', event.value);
    this.referencedMaterialId = event.value;
  }

  onFormSubmit() {
    const material = this.model.toPlainObj();
    material.manualSpecified = true;
    console.log('form submit for new material: ', this.forOrderBuild, this.model, material);
    this.submitted = true;

    if (this.forOrderBuild) {
      this.model.referencedMaterialId = this.referencedMaterialId;
      this.onSubmit.emit(this.model);
      return;
    }

    let action;
    if (this._editMode && !(this.type === 'copy')) {
      action = this.dataService.updateMaterial(this.budgetId, this.subBudgetId, material);
    } else {
      action = this.dataService.addMaterial(this.budgetId, this.subBudgetId, material);
    }

    action.subscribe(() => {
      this.onSubmit.emit(this.model);
    });
  }

  ngOnInit() {
    this.dataService.getItemCategories().subscribe((c) => {
      this.categories = c;
    });
  }

}
